<template>
<div class="cflist">
  <div v-for="item in cfarr">
    <div style="padding-left: 10px;" v-if="item.S_OP_Json.S_OP_IO_Type == 0">
      <p class="bt">框架远用</p>
      <ul class="kjyy">
        <li>眼别</li>
        <li>球镜</li>
        <li>柱镜</li>
        <li>轴向</li>
        <li>ADD</li>
        <li>远用矫正视力</li>
        <li>近用矫正视力</li>
        <li>瞳距</li>
        <li>瞳高</li>
        <li>垂直棱镜</li>
        <li>垂直基底</li>
        <li>水平棱镜</li>
        <li>水平基底</li>
      </ul>
      <ul class="kjyy">
        <li>OD</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ADDOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DVAOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_NVAOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PDOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PHOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ArriseOD_V}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BasisOD_V}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ArriseOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BasisOD}}</li>
      </ul>
      <ul class="kjyy">
        <li>OS</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ADDOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DVAOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_NVAOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PDOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PHOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ArriseOS_V}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BasisOS_V}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_ArriseOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BasisOS}}</li>
      </ul>
    </div>

    <div style="padding-left: 10px;margin-top: 20px;" v-if="item.S_OP_Json.S_OP_IO_Type == 2">
      <p class="bt">框架近用</p>
      <ul class="kjjy">
        <li>眼别</li>
        <li>球镜</li>
        <li>柱镜</li>
        <li>轴向</li>
        <li>近用视力矫正</li>
        <li>瞳距</li>
      </ul>
      <ul class="kjjy">
        <li>OD</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_VAOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PDOD}}</li>
      </ul>
      <ul class="kjjy">
        <li>OS</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_VAOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_PDOS}}</li>
      </ul>
    </div>


    <div style="padding-left: 10px;margin-top: 20px;" v-if="item.S_OP_Json.S_OP_IO_Type == 7">
      <p class="bt">角膜接触镜</p>
      <ul class="kjjy">
        <li>眼别</li>
        <li>球镜</li>
        <li>柱镜</li>
        <li>轴向</li>
        <li>视力</li>
        <li>基弧</li>
        <li>镜片直径</li>
      </ul>
      <ul class="kjjy">
        <li>OD</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_VAOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BCOD}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DIMOD}}</li>
      </ul>
      <ul class="kjjy">
        <li>OS</li>
        <li>{{item.S_OP_Json.S_OP_IO_DSOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DCOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_XOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_VAOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_BCOS}}</li>
        <li>{{item.S_OP_Json.S_OP_IO_DIMOS}}</li>
      </ul>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "cflist",
  data() {
    return {
      cfarr: []
    }
  },
  created() {
    if (!this.$store.state.users.employees) {
      return this.$alert('员工未登录！', '提示')
          .then(res => {
            this.$router.push({path: '/employeesLanding'})
          })
    }
    if (!this.$store.state.users.CsUser && !this.$store.state.physicianVisits.xzConsulting) { return }
    let log = this.$loading({text: '...'})
    this._api.expertClinic.getViewPlan()
        .then(res => {
          this.showcf = true
          log.close()
          if (res.GetListResult && res.GetListResult.length > 0) {
            let arr = res.GetListResult.filter(item => item.S_OP_Model == "S_OP_IO")
            this.cfarr = arr.map(item => {
              item.S_OP_Json = this._clJson(item.S_OP_Json)
              return item
            })
          }
        })
  }
}
</script>

<style scoped lang="scss">
.cflist {
  width: 100%;
}
.kjyy {
  display: flex;
  width: 1000px;
  border: 1px solid #7f7e7e;
  li {
    width: 5em;
    border-right: 1px solid #7f7e7e;
    padding: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  li:nth-child(6) {width: 7em;}
  li:nth-child(7) {width: 7em;}
}
.bt {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 10px;
}
.kjjy {
  display: flex;
  width: 1000px;
  border: 1px solid #7f7e7e;
  li {
    width: 200px;
    border-right: 1px solid #7f7e7e;
    padding: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
